import { useCallback } from 'react'
import { ContextMenu } from '@highlight/ui'
import { Zap } from 'lucide-react'
import { useSubmitMessage } from '@renderer/chat/hooks'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'
import type { ReminderItem } from '@renderer/overlay/Sidepanel/hooks/use-reminders'
import { useViewActions } from '../../../view-atoms'
import {
  buildReminderDraftPrompt,
  buildReminderMetadataText,
  REMINDER_ATTACHMENT_LABEL,
} from '../utils/build-draft-prompt'

interface DraftActionMenuItemProps {
  item: ReminderItem
}

export function DraftActionMenuItem({ item }: DraftActionMenuItemProps) {
  const submitMessage = useSubmitMessage()
  const { openView } = useViewActions()

  const handleClick = useCallback(() => {
    AmplitudeRenderer.trackEvent('Reminder Action', { type: 'Draft' })
    void submitMessage(buildReminderDraftPrompt(item), {
      isNewChat: true,
      attachments: [
        {
          attachment: { type: 'clipboardText', text: buildReminderMetadataText(item) },
          metadata: { label: REMINDER_ATTACHMENT_LABEL },
        },
      ],
      onSubmit: (conversationId: string) => {
        openView('chat', { chatId: conversationId, instantScrollToBottom: true }, { sourceLabel: 'Reminders' })
      },
    })
  }, [item, submitMessage, openView])

  return (
    <ContextMenu.Item onClick={handleClick}>
      <Zap />
      <span>Draft action</span>
    </ContextMenu.Item>
  )
}
